import { MouseEventHandler } from "react";
import { Link } from "@mui/material";
import { Highlight } from "src/components/common/highlight";
import { Typography } from "src/components-mui/base/typography/typography";
import { SearchItemLogo } from "src/components-mui/common/typeahead/nav-search-item/shared/search-item-logo";
import { getNavSearchItemStyles } from "src/components-mui/common/typeahead/nav-search-item/shared/styles";
import { IPlacement } from "src/components-mui/common/typeahead/typeahead.types";
import { useLinkBuilder } from "src/hooks/use-link-builder";
import { getTrackingUrlParam } from "src/utils/search-tracking-util";

const NAV_MARKET_INDICATOR_SEARCH_ITEM_TEST_ID = "nav-market-indicator-search-item";

interface IMarketIndicatorSearchItem {
    shortDescription: string;
    resourceIdentifier: string;
    logoUrl: string;
    isSelected?: boolean;
    query?: string;
    onClick?: MouseEventHandler;
    placement: IPlacement;
}

export const MarketIndicatorSearchItem = ({
    shortDescription,
    resourceIdentifier,
    logoUrl,
    isSelected = false,
    query,
    onClick,
    placement,
}: IMarketIndicatorSearchItem) => {
    const { buildMarketIndicatorLink } = useLinkBuilder();

    return (
        <Link
            href={buildMarketIndicatorLink(resourceIdentifier) + getTrackingUrlParam({ placement, query })}
            onClick={onClick}
            data-test-id={NAV_MARKET_INDICATOR_SEARCH_ITEM_TEST_ID}
            underline="none"
            sx={getNavSearchItemStyles(isSelected)}
        >
            <SearchItemLogo logoUrl={logoUrl} shortDescription={shortDescription} />
            <Typography noWrap sx={{ flexGrow: 1 }}>
                <Highlight source={shortDescription} target={query} />
            </Typography>
        </Link>
    );
};
